import React, { FC, useEffect, useState } from "react";
import Dialog from "../../dialog";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
  StepContainer,
  StepName,
  RotateImg,
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import * as yup from 'yup';
import { useFormik } from 'formik';
import Input from "../../input";
import { HeadLine3 } from "../../typography/styled";

            
type ModalProps = {
  closeModalCancel:() => void;
  closeModal:(data:any) => void;
  alertTitle:string;
  instance?:any;
  loading?:boolean;
}  

const ReinstallStatus:FC<ModalProps> = (props) => {
  const {
    closeModal,
    closeModalCancel,
    alertTitle,
    instance,
    loading
  } = props
  const [t] = useTranslation()
  const onSubmit = (values:any) => {
    closeModal(values)
  }

  const steps = [
    //Rebooting Server
    {step:0, title:t("REBOOTING_SERVER")},
    //Preparing Boot environment
    {step:1, title:t("PREPARING_BOOT_ENV")},
    //Installing operating system
    {step:2, title:t("INSTALLING_OPERATING_SYSTEM")},
    //Installation completed
    {step:3, title:t("INSTALLING_COMPLETED")},
  ]
  console.log('instance', instance);
  return(
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{marginLeft:'10px', marginTop:'10px'}}>
          {t("PROGRESS")}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap:'6px'
        }}>
          {steps.map((step:any, index:any) => (
            <StepContainer>
              <RotateImg
                active={step.step === instance.step && instance.step !== 3}
                src={step.step === instance.step && step.step !== 3 ?
                  icons.Restart
                  :
                  (instance.step > step.step || instance.step === 3  ?
                    icons.TwoMark
                    : ''
                    )
                }
              />
              <StepName>
                {step?.title}
              </StepName>
            </StepContainer>
          ))}
        </div>
        <div style={{display:"flex", gap:'6px', marginTop:'30px'}}>
          {/* <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          /> */}
          <Button
            variant="primary"
            size="display"
            loading={loading}
            customStyles={{ width: '100%', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("CLOSE")}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default ReinstallStatus